import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { addVisitedPath } from '@/lib/helpers/visitedPaths'
import { pathToLabel } from '@/lib/helpers/pathToLabel'

const SKIP_PATHS = ['/', '/login', '/reset_password', '/not-found']

export default function useRecordVisitedPath(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    if (SKIP_PATHS.includes(pathname)) return
    // Skip bare /project_stages and /project_stages/:id (redirect-only routes)
    if (/^\/project_stages(\/[^/]+)?$/.test(pathname)) return

    // Recording a breadcrumb is cosmetic — it must never be able to take down
    // the app. This hook is mounted in Root (routes.tsx `path: '/'`), which
    // declares no errorElement, so anything thrown here propagates to the
    // GlobalLayout boundary and unmounts the entire authenticated shell; the
    // error page's only recovery is a reload, which re-runs the same effect
    // and traps the user in a loop. That is how a missing `Array.prototype.at`
    // in pathToLabel took out the whole app on an old WebView. Log and carry on
    // instead: console.error still reaches monitoring (captureConsoleErrors),
    // so the failure stays visible without being fatal.
    try {
      const { labelKey, labelFallback, detail } = pathToLabel(pathname)
      addVisitedPath({ path: pathname, labelKey, labelFallback, detail })
    } catch (error) {
      console.error('[visitedPaths] failed to record visited path:', error)
    }
  }, [pathname])
}
